/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookie_TitleInputs */

const en_cookie_title = /** @type {(inputs: Cookie_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookie Preferences`)
};

const lv_cookie_title = /** @type {(inputs: Cookie_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sīkdatņu iestatījumi`)
};

/**
* | output |
* | --- |
* | "Cookie Preferences" |
*
* @param {Cookie_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cookie_title = /** @type {((inputs?: Cookie_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookie_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cookie_title(inputs)
	return en_cookie_title(inputs)
});